export default function showToast(options: {
    title: string;
    description?: string;
    type: 'success' | 'error' | 'warning' | 'info';
    duration?: number;
}) {
    const duration = options.duration ?? 3000;
    const toast = document.createElement('div');
    toast.classList.add('toast');
    toast.classList.add(options.type);

    toast.innerHTML = `<div class="toast-title">${options.title}</div>`;
    if (options.description) {
        toast.innerHTML += `<div class="toast-description">${options.description}</div>`;
    }
    document.body.appendChild(toast);
    setTimeout(() => {
        toast.classList.add('active');
    }, 100);

    setTimeout(() => {
        toast.classList.remove('active');
        setTimeout(() => {
            toast.remove();
        }, 100);
    }, duration);
}
